import { TableColumn } from '@/rtkApi/mddApiSliceGenerated'
import { TableColumnFlat } from '@/store/modules/table/types'

import { ColumnValidationResult, GetColumnPickerData } from './types'

export const getColumnPickerData: GetColumnPickerData = ({
	tableColumns,
	pickedColumns,
}) => {
	const findMatch = (pickedCol: TableColumn) =>
		tableColumns?.find((c) => pickedCol?.uuid && pickedCol.uuid === c?.uuid) ||
		tableColumns?.find((c) => pickedCol?.code && pickedCol.code === c?.code)

	return pickedColumns.map((pickedCol) => {
		const matchedColumn = findMatch(pickedCol)
		return {
			payload: pickedCol,
			rest: matchedColumn || pickedCol, // fallback to the original column
		}
	})
}

// New enhanced function
export const validateAndCategorizeColumns = ({
	tableColumns,
	pickedColumns,
}: {
	pickedColumns: TableColumnFlat[]
	tableColumns: TableColumnFlat[]
}): ColumnValidationResult => {
	const validColumns: Array<{
		payload: TableColumnFlat
		rest: TableColumnFlat
	}> = []

	const deprecatedColumns: TableColumnFlat[] = []

	pickedColumns.forEach((pickedCol) => {
		const matchedColumn = tableColumns?.find(
			(c) => pickedCol?.uuid && pickedCol.uuid === c?.uuid,
		) || tableColumns?.find((c) => pickedCol?.code && pickedCol.code === c?.code)

		if (matchedColumn) {
			validColumns.push({
				payload: pickedCol,
				rest: matchedColumn,
			})
		} else if (!matchedColumn && pickedCol.uuid) {
			deprecatedColumns.push(pickedCol)
		}
	})

	return {
		validColumns,
		deprecatedColumns,
		hasDeprecatedColumns: deprecatedColumns.length > 0,
	}
}
